import { render, staticRenderFns } from "./BusinessBranchOrCategorySearchResultCard.vue?vue&type=template&id=2aa94cfe&scoped=true"
import script from "./BusinessBranchOrCategorySearchResultCard.vue?vue&type=script&lang=ts"
export * from "./BusinessBranchOrCategorySearchResultCard.vue?vue&type=script&lang=ts"
import style0 from "./BusinessBranchOrCategorySearchResultCard.vue?vue&type=style&index=0&id=2aa94cfe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa94cfe",
  null
  
)

export default component.exports